module.exports = __webpack_public_path__ + "static/media/lalashan_plant.b6a18df9.webp";